import { LayoutPublic } from 'components/layout';
import { ObjectiveSteps, WelcomeStep } from 'components/onboarding';
import IntegrationsStep from 'components/onboarding/IntegrationsStep';
import { OnboardingContextProvider } from 'components/onboarding/OnboardingContext';
import { PricingStep } from 'components/onboarding/PricingStep';
import { ProfileStep } from 'components/onboarding/ProfileStep';
import { RecommendedSegmentsStep } from 'components/onboarding/RecommendedSegmentsStep';
import { Route, Switch } from 'react-router-dom';
import { usePageTitle } from 'utils';

export default function OnboardingPage() {
  usePageTitle('Onboarding | Segments');

  return (
    <OnboardingContextProvider>
      <LayoutPublic>
        <Switch>
          <Route exact path="/onboarding" component={WelcomeStep} />
          <Route
            exact
            path="/onboarding/objectives"
            component={ObjectiveSteps}
          />
          <Route exact path="/onboarding/profile" component={ProfileStep} />
          <Route
            exact
            path="/onboarding/recommended_segments"
            component={RecommendedSegmentsStep}
          />
          <Route
            exact
            path="/onboarding/integrations"
            component={IntegrationsStep}
          />
          <Route exact path="/onboarding/pricing" component={PricingStep} />
        </Switch>
      </LayoutPublic>
    </OnboardingContextProvider>
  );
}
